export default "__VITE_ASSET__4hySCYXt__"